
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import { computed, defineComponent } from "vue";
import Modal from "../General/Modal.vue";
import ButtonGroup from "../Buttons/ButtonGroup.vue";
import Button from "../Buttons/Button.vue";
import { mdiClose, mdiPrinter } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import TextButton from "../Buttons/TextButton.vue";
import { emit } from "process";
import ValidationFormErrors from "../Forms/ValidationFormErrors.vue";

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      default: () => false,
    },
    numberOfTags: {
      type: Number,
      required: true,
    },
  },
  emits: ["dismiss"],
  setup(props, context) {
    const page = usePage();

    const form = useForm({
      size: "large" as "small" | "large",
      priceType: "auto" as "auto" | "normal" | "campaign",
      filter: page.props.value.form,
      customText: "",
    });

    const customTextVisible = computed(() => {
      if (form.size === "small") {
        return false;
      }

      return true;
    });

    const sizeOptions = [
      {
        value: "small",
        label: "Liten",
      },
      {
        value: "large",
        label: "Stor",
      },
    ];

    const priceOptions = [
      {
        value: "auto",
        label: "Nåværende pris",
      },
      {
        value: "normal",
        label: "Normalpris",
      },
      {
        value: "campaign",
        label: "Kampanjepris",
      },
    ];

    const submit = () => {
      form
        .transform((data) => {
          if (!customTextVisible.value) {
            data.customText = "";
          }

          return data;
        })
        .post(route("products.label.print.bulk"), {
          onSuccess: () => {
            context.emit("dismiss");
          },
        });
    };

    return {
      form,
      submit,
      sizeOptions,
      priceOptions,
      printIcon: mdiPrinter,
      closeIcon: mdiClose,
      customTextVisible,
    };
  },
  components: {
    Modal,
    ButtonGroup,
    Button,
    SvgIcon,
    TextButton,
    ValidationFormErrors,
  },
});
